/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <span
    class="row"
  >
    <span
      v-for="assignment in assignments"
      :ref="'assignment-' + assignment.assignmentId"
      class="col-xs-6 col-sm-4"
      :class="getClass(assignment)"
    >
      <strong>
        <router-link
          :to="{ name: 'preview-assignment',
                 params: {assignmentId: assignment.assignmentId } }"
        >
          <!-- eslint-disable-next-line -->
          <svg v-if="!assignment.isTemplate && assignment.groupTargets && assignment.groupTargets.length" class="assignmentIcon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- eslint-disable-next-line -->
            <rect width="18" height="18" rx="2" fill="#F26724"/>
            <!-- eslint-disable-next-line -->
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.70638 7.02625L6 6.30176C7.75512 4.56386 10.3813 4.5683 12.0671 6.30176L11.3607 7.02625C9.98261 5.79506 8.01514 5.79506 6.70638 7.02625ZM9.03348 9.4442C9.99121 9.4442 10.7669 10.2398 10.7669 11.2221C10.7669 12.2044 9.99121 13 9.03348 13C8.07574 13 7.30002 12.2044 7.30002 11.2221C7.30002 10.2398 8.07574 9.4442 9.03348 9.4442ZM9.0335 10.3331C8.5568 10.3331 8.16678 10.7332 8.16678 11.2221C8.16678 11.711 8.5568 12.1111 9.0335 12.111C9.5102 12.111 9.90023 11.711 9.90023 11.2221C9.90023 10.7332 9.5102 10.3331 9.0335 10.3331ZM8.18844 8.51969C8.69981 8.14634 9.36285 8.14633 9.87422 8.51969L10.6066 7.77298C9.73121 6.87514 8.40945 6.87514 7.45605 7.77298L8.18844 8.51969Z" fill="white"/>
            <!-- eslint-disable-next-line -->
            <path d="M17.1129 7.91066C17.0603 7.79854 16.9479 7.72733 16.8251 7.72733H15.8811C15.2818 4.47349 12.4246 2 9 2C5.14011 2 2 5.14043 2 9C2 12.8596 5.14011 16 9 16C11.4906 16 13.8139 14.6593 15.0624 12.5016C15.2387 12.1978 15.1346 11.8082 14.8304 11.632C14.5256 11.4564 14.1367 11.5598 13.9608 11.8646C12.9388 13.6299 11.0382 14.728 9 14.728C5.84185 14.727 3.27267 12.1585 3.27267 9C3.27267 5.84185 5.84185 3.27299 8.99968 3.27299C11.72 3.27299 13.9985 5.1807 14.5791 7.72733H13.6431C13.5197 7.72733 13.4079 7.79886 13.3548 7.91066C13.3023 8.02246 13.3203 8.15424 13.3986 8.24929L14.9896 10.1586C15.0502 10.2311 15.1401 10.2727 15.2341 10.2727C15.3285 10.2727 15.4175 10.2308 15.4784 10.1586L17.0694 8.24929C17.1483 8.15424 17.1657 8.02246 17.1129 7.91066Z" fill="white"/>
          </svg>
          <!-- eslint-disable-next-line -->
          <svg v-else-if="!assignment.isTemplate" class="assignmentIcon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- eslint-disable-next-line -->
            <rect width="18" height="18" rx="2" fill="#F26724"/>
            <!-- eslint-disable-next-line -->
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.30115 6.03938L4.24158 4.95263C6.87426 2.34579 10.8135 2.35245 13.3422 4.95263L12.2826 6.03938C10.2155 4.19258 7.26429 4.19258 5.30115 6.03938ZM8.79186 9.6663C10.2285 9.6663 11.392 10.8597 11.392 12.3331C11.392 13.8066 10.2285 15 8.79186 15C7.35526 15 6.19168 13.8066 6.19168 12.3331C6.19168 10.8597 7.35526 9.6663 8.79186 9.6663ZM8.79189 10.9997C8.07684 10.9997 7.4918 11.5998 7.4918 12.3332C7.4918 13.0665 8.07684 13.6666 8.79189 13.6666C9.50694 13.6666 10.092 13.0665 10.092 12.3332C10.092 11.5998 9.50694 10.9997 8.79189 10.9997ZM7.52423 8.27954C8.29129 7.7195 9.28586 7.7195 10.0529 8.27954L11.1515 7.15946C9.8384 5.8127 7.85576 5.8127 6.42566 7.15946L7.52423 8.27954Z" fill="white"/>
          </svg>
          <span class="assignmentName">
            {{ assignment.name | truncate25 }}
          </span>

          <router-link
            v-if="!assignment.isGlobal"
            style="float: right;"
            :to="{ name: 'preview-assignment',
                   params: {assignmentId: assignment.assignmentId } }"
          >
            <svg class="svgicon icon-pencil">
              <use xlink:href="/static/svg-symbols.svg#icon-pencil" />
            </svg>
          </router-link>
        </router-link>
      </strong>
      <div
        v-if="!assignment.isTemplate"
        class="assignment-status"
      >
        Status: {{ getStatus(assignment) }}
      </div>
      <div
        :class="assignment.isTemplate ? 'assignment-description template-description' :'assignment-description'"
      >
        {{ assignment.description }}
      </div>
      <div
        class="attachmentsLinkContainer"
      >
        <router-link
          v-if="!assignment.isGlobal"
          :to="{ name: 'edit-assignment',
                 params: {assignmentId: assignment.assignmentId, stepNum: assignmentStepsByName.attachments } }"
          class="attachmentsLink"
        >
          <svg class="icon-file">
            <use xlink:href="/static/svg-symbols.svg#icon-file" />
          </svg>
          <span>
            {{ assignment.attachments ? assignment.attachments.length : 0 }} ATTACHMENT{{
              (assignment.attachments && assignment.attachments.length && assignment.attachments.length == 1) ? '' : 'S' }}
          </span>
          <span class="assignmentRecordingType">
            {{ getRecordingType(assignment) }}
          </span>
        </router-link>
        <div
          v-else
          class="attachmentsLink"
        >
          <svg class="icon-file">
            <use xlink:href="/static/svg-symbols.svg#icon-file" />
          </svg>
          <span>
            {{ assignment.attachments ? assignment.attachments.length : 0 }} ATTACHMENT{{
              (assignment.attachments && assignment.attachments.length && assignment.attachments.length == 1) ? '' : 'S' }}
          </span>
        </div>
      </div>
      <div
        v-if="!assignment.isTemplate"
        class="assignmentStats rTable"
        @click="$router.replace({ name: 'preview-assignment',
                                  params: {assignmentId: assignment.assignmentId },
                                  query: {collapsed: 1 } })"
      >
        <div class="rTableRow">
          <div class="rTableCell rTableCellBorder">
            NOT STARTED<br>
            <span class="stat">
              {{ assignment.assignmentNotStartedCount }}/{{ assignment.assignmentAssignedCount }}
            </span>
            <svg class="icon-eye-slash">
              <use xlink:href="/static/svg-symbols.svg#icon-eye-slash" />
            </svg>
          </div>
          <div class="rTableCell rTableCellBorder">
            IN PROGRESS<br>
            <span class="stat">
              {{ assignment.assignmentInProgressCount }}/{{ assignment.assignmentAssignedCount }}
            </span>
            <svg class="icon-refresh">
              <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
            </svg>
          </div>
          <div class="rTableCell rTableCellBorder">
            COMPLETED<br>
            <span class="stat">
              {{ assignment.assignmentCompletedCount }}/{{ assignment.assignmentAssignedCount }}
            </span>
            <svg class="icon-checkmark">
              <use xlink:href="/static/svg-symbols.svg#icon-checkmark" />
            </svg>
          </div>
          <div class="rTableCell rTableCellBorder">
            RECORDINGS<br>
            <span class="stat">
              {{ assignment.recordings.length }}
            </span>
            <svg class="icon-microphone">
              <use xlink:href="/static/svg-symbols.svg#icon-microphone" />
            </svg>
          </div>
          <div class="rTableCell rTableCellBorder">
            FOR REVIEW<br>
            <span class="stat">
              {{ assignment.assignmentForReviewCount }}
            </span>
            <svg class="icon-flag">
              <use xlink:href="/static/svg-symbols.svg#icon-flag" />
            </svg>
          </div>
          <div class="rTableCell">
            COMMENTS<br>
            <span class="stat">
              {{ assignment.feedbackCount }}
            </span><svg class="icon-comment">
              <use xlink:href="/static/svg-symbols.svg#icon-comment" />
            </svg>
          </div>
        </div>
      </div>
    </span>
  </span>
</template>

<style lang="less" scoped>
  .assignmentIcon {
    margin-right: 4px;
  }
  .icon-comment, .icon-eye-slash, .icon-refresh, .icon-flag, .icon-microphone, .icon-checkmark {
    color: #333;
    width: 12px; height: 12px;
    position: relative;
    top: 3px;
  }
  .rTable { display: table; width: 100%}
  .rTableRow { display: table-row; }
  .rTableCell {
    display: table-cell; width: 16%; text-align: center; font-size: 5pt;
    font-weight: 400;
    span {
      font-size: 9px;
    }
  }
  .rTableCellBorder { border-right: 1px solid #ccc; }
  hr {
    margin: 5px;
  }
  .assignmentStats {
    cursor: pointer;
    padding-top: 10px;
    color: #333;
    font-size: 11px;
    .stat {
      color: #DE2800;
    }
  }
  .assignmentName {
    color: #333;
    font-size: 14pt;
  }
  .assignment-status {
    font-size: 9px;
    font-weight: 400;
  }

  .assignment-description {
    font-size: 14px;
    font-weight: 400;
    height: 60px;
    padding-bottom: 0;
    overflow: hidden;
    border-top: 1px solid #ccc;
  }
  .attachmentsLink {
    font-size: 9px;
    text-decoration: none;
    span {
      position: relative;
      bottom: 2px;
      left: 2px;
    }
  }
  .attachmentsLinkContainer {
    border-bottom: 1px solid #ccc;
    a {
      color: #333;
    }
  }
  .assignmentRecordingType {
    float: right;
    position: relative;
    top: 4px;
  }
  .icon-file {
    width: 14px;
    height: 14px;
  }
  .svgicon {
    display: inline-block;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
  .icon-pencil {
    width: 16px; height: 16px;
  }
  .assignment {
    height: 182px;
    width: 355px;
    margin: 10px 20px 10px 0;
    padding: 10px;
    background-color: #f2f2f2;
    border-radius: 8px;
  }
  .assignmentIcon {
    position: relative;
    top: 2px;
  }
  .assignment-description.template-description {
    height: 120px;
  }
  .assignment-deleted {
    opacity: 0;
    transition: opacity 1s linear;
  }
  span.row {
    margin-top: 0;
    padding-top: 0;
  }
  /*
  .completed {
    background-color: #a4c9cb;
    .assignmentStats {
      color: black;
    }
  }
  */
</style>

<script>
export default {
  props: [ 'assignments' ],
  data() {
    return {
      tab: 'next steps',
    };
  },
  computed: {
    assignmentStepsByName() {
      return this.$store.getters.appConfig.assignmentStepsByName;
    }
  },
  watch: {
  },
  methods: {
    getClass(assignment) {
      if (assignment.archived || assignment.deleted ||
        (!assignment.isTemplate &&
        assignment.assignmentAssignedCount == assignment.assignmentCompletedCount &&
        (!assignment.groupTargets || !assignment.groupTargets.length))) {
        return 'assignment completed';
      }
      return 'assignment pending';
    },
    getRecordingType(assignment) {
      if (!assignment.criteria || !assignment.criteria.algorithm) return '';
      return assignment.criteria.algorithm.indexOf('conversational') === -1 ?
        'SINGLE SPEAKER' : 'MULTI-SPEAKER';
    },
    getStatus(assignment) {
      if (assignment.archived || assignment.deleted) {
        return 'Disabled/Archived';
      }
      let baseStatus = (assignment.assignmentAssignedCount == assignment.assignmentCompletedCount &&
        (!assignment.groupTargets || !assignment.groupTargets.length)) ?
        'Completed' : 'Active';
      if (assignment.groupTargets && assignment.groupTargets.length) {
        baseStatus += ' (Continuous Group Assignment)';
      } else {
        baseStatus += ' (Non-Continuous Assignment)';
      }
      return baseStatus;
    },
  }
};
</script>
